module.exports = __webpack_public_path__ + "static/media/Stonk-Logo.3af7845f.png";